import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { JdTransferListComponent } from './transfer-list.component';
import { JdTransferSearchComponent } from './transfer-search.component';
import { JdTransferComponent } from './transfer.component';
import {MatButtonModule, MatCardModule, MatCheckboxModule, MatIconModule, MatInputModule} from '@angular/material';
import {PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
@NgModule({
  imports:      [
    CommonModule,
    FormsModule,
    MatCheckboxModule,
    MatButtonModule,
    MatInputModule,
    MatIconModule,
    MatCardModule,
    PerfectScrollbarModule
  ],
  declarations: [JdTransferComponent, JdTransferListComponent, JdTransferSearchComponent],
  exports:      [JdTransferComponent]
})
export class JdTransferModule { }
